import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import {
	useLocalizedHref,
	useLocalizedHrefTrello,
} from '@/libraries/web-framework/src/localization/use-localized-href';
import {
	Adg4OffsetIconCollection,
	IconDataProps,
} from '@/patterns/adg4/offset-icon-collection/offset-icon-collection';
import { ScrollTracking } from '@/utils/scroll-tracking/scroll-tracking';

const IntegrationsSection = () => {
	const intl = useIntl();

	const iconData: IconDataProps[] = [
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.jira-logo-alt',
				defaultMessage:
					'The Jira logo which resembles three arrowheads pointing up and to the right.',
			}),
			href: useLocalizedHref('/software/confluence/jira-integration'),
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.loom-logo-alt',
				defaultMessage: 'Loom logo',
			}),
			href: 'https://marketplace.atlassian.com/apps/1225947/loom-for-confluence',
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.trello-logo-alt',
				defaultMessage: 'Trello logo which resembles a trello board with two columns.',
			}),
			href: useLocalizedHrefTrello('/'),
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.microsoft-teams-logo-alt',
				defaultMessage: 'Microsoft Teams logo',
			}),
			href: useLocalizedHref('/software/confluence/microsoft-teams-integration'),
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.figma-logo-alt',
				defaultMessage: 'Figma logo',
			}),
			href: 'https://marketplace.atlassian.com/apps/1221692/figma-for-confluence',
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.slack-logo-alt',
				defaultMessage: 'Slack logo',
			}),
			href: 'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official',
		},
		{
			url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg',
			altText: intl.formatMessage({
				id: 'ConfluenceSoftwarePageTemplate.integrations.google-drive-logo-alt',
				defaultMessage: 'Google Drive logo',
			}),
			href: 'https://marketplace.atlassian.com/apps/1216978/google-drive-and-docs-for-confluence',
		},
	];

	const headingText = intl.formatMessage({
		id: 'ConfluenceSoftwarePage.v4.integrationsSection.header',
		defaultMessage: 'Integrate with your faves',
	});
	const bodyText = intl.formatMessage({
		id: 'ConfluenceSoftwarePage.v4.integrationsSection.body',
		defaultMessage: 'All the tools you know and love integrate smoothly with Confluence',
	});
	const ctaText = intl.formatMessage({
		id: 'ConfluenceSoftwarePage.v4.integrationsSection.cta',
		defaultMessage: 'Go to Marketplace',
	});

	return (
		<UFOSegment name="confluence-pt-cfind-1234-integrationsSection">
			<ScrollTracking section="IntegrationsSection">
				<Adg4OffsetIconCollection
					iconData={iconData}
					headingText={headingText}
					bodyText={bodyText}
					ctaText={ctaText}
					productKey="confluence"
					ctaLink="https://marketplace.atlassian.com/addons/app/confluence"
				/>
			</ScrollTracking>
		</UFOSegment>
	);
};
IntegrationsSection.displayName = 'IntegrationsSection';

export default IntegrationsSection;
